export = {
  0: 'Member',
  1: 'Administrator',
  2: 'Super Administrator'
};
